/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import classnames from 'classnames';

import { ShimmerLoading } from 'src/components/common/loading/ShimmerLoading';

// To prevent flakes we should use a set of static randomly generated values
// between 0 and 70 to simulate actual sdl patterns
//
const shimmerLoaderWidths = [
  29, 69, 24, 40, 27, 67, 27, 16, 2, 22, 17, 0, 0, 23, 0, 0, 12, 19, 62, 0, 0,
  51, 23, 0, 1, 59, 0, 67, 9, 0,
];

export const SDLShimmerLoading = ({ className }: { className?: string }) => {
  return (
    <div className={classnames('chromatic-ignore mt-1', className)}>
      {shimmerLoaderWidths.map((width, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={i} className="mt-2 flex">
          <ShimmerLoading className="ml-14 mr-5 w-4" />
          <ShimmerLoading
            css={css`
              width: ${width}%;
            `}
            className="ml-1.5 mr-3"
          />
        </div>
      ))}
    </div>
  );
};
